var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "683.82935mm",
    height: "68.317528mm",
    viewBox: "0 0 683.82935 68.317528",
    id: "svg1733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(454.55158,-45.216233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -447.67807,46.087241 4.63021,35.095744 0.0882,1.328561 c 0.21661,2.932289 0.33902,4.858808 0.36936,5.776736 0.0289,-1.557161 0.16686,-3.926064 0.41346,-7.105297 l 5.03801,-32.345135 h 5.3139 l 4.90572,31.93168 c 0.30445,3.392663 0.48648,5.898091 0.54575,7.518752 0,-0.216605 0.0138,-1.041753 0.0441,-2.475089 0.0332,-1.435805 0.18732,-3.147483 0.46284,-5.131858 l 4.53673,-34.594094 h 6.87352 l -8.9849,66.299999 h -5.53967 l -5.13186,-36.016496 c -0.1845,-2.196395 -0.30727,-4.365625 -0.369,-6.504164 -0.0303,1.069269 -0.1517,3.22333 -0.36407,6.460066 l -5.13186,36.060594 h -5.58906 l -8.98489,-66.299999 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -365.38031,98.502257 c 0,4.674303 -1.09396,8.349543 -3.27942,11.024303 -2.18299,2.67194 -5.3661,4.0072 -9.54723,4.0072 -4.21957,0 -7.41256,-1.33526 -9.58003,-4.0072 -2.16923,-2.67476 -3.25226,-6.35 -3.25226,-11.024303 V 60.242449 c 0,-4.670424 1.08303,-8.34143 3.25226,-11.013369 2.16747,-2.674761 5.36046,-4.012847 9.58003,-4.012847 8.55063,0 12.82665,5.009092 12.82665,15.026216 z m -8.65928,7.424913 c 1.21955,-1.52823 1.82986,-4.00332 1.82986,-7.424913 V 60.242449 c 0,-6.136569 -1.99955,-9.205383 -5.99723,-9.205383 -1.95544,0 -3.44522,0.719314 -4.4704,2.15512 -1.02235,1.433336 -1.53246,3.784247 -1.53246,7.050263 v 38.259808 c 0,3.271313 0.51011,5.625043 1.53246,7.060843 1.02518,1.43334 2.51496,2.14983 4.4704,2.14983 1.86302,0 3.25226,-0.59513 4.16737,-1.78576 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -313.6017,98.502257 c 0,4.674303 -1.09432,8.349543 -3.27978,11.024303 -2.18299,2.67194 -5.3661,4.0072 -9.54687,4.0072 -4.21958,0 -7.41257,-1.33526 -9.58039,-4.0072 -2.16888,-2.67476 -3.25226,-6.35 -3.25226,-11.024303 V 60.242449 c 0,-4.670424 1.08338,-8.34143 3.25226,-11.013369 2.16782,-2.674761 5.36081,-4.012847 9.58039,-4.012847 8.55063,0 12.82665,5.009092 12.82665,15.026216 z m -8.65964,7.424913 c 1.21955,-1.52823 1.83021,-4.00332 1.83021,-7.424913 V 60.242449 c 0,-6.136569 -1.99954,-9.205383 -5.99722,-9.205383 -1.95545,0 -3.44523,0.719314 -4.4704,2.15512 -1.0227,1.433336 -1.53247,3.784247 -1.53247,7.050263 v 38.259808 c 0,3.271313 0.50977,5.625043 1.53247,7.060843 1.02517,1.43334 2.51495,2.14983 4.4704,2.14983 1.86302,0 3.2519,-0.59513 4.16701,-1.78576 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -274.19396,46.087241 c 4.30636,0 7.44397,1.680987 9.41458,5.043664 1.96921,3.359503 2.95452,8.030986 2.95452,14.017272 v 28.178125 c 0,5.986286 -0.99484,10.660588 -2.98203,14.022918 -1.98438,3.3595 -5.11387,5.03802 -9.38707,5.03802 h -12.83229 V 46.087241 Z m -6.46042,5.815189 v 54.66397 h 6.00287 c 1.55434,0 2.85115,-0.83925 3.89149,-2.51883 1.403,-2.32198 2.10573,-5.895269 2.10573,-10.721268 V 65.148177 c 0,-8.83038 -1.99954,-13.245747 -5.99722,-13.245747 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -228.92551,106.61615 h 17.27517 v 5.77109 h -24.05521 V 46.175436 h 6.78004 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -171.97095,93.921438 -4.39879,-21.442186 c -0.0924,-0.430036 -0.23036,-1.467556 -0.41346,-3.114322 -0.18485,-1.557161 -0.32244,-2.580922 -0.41345,-3.070225 l -0.36372,3.114322 c -0.18485,1.5875 -0.32243,2.640189 -0.41345,3.158419 l -3.48368,21.353992 z m 1.10243,5.820833 h -11.68577 l -2.47509,12.644969 h -6.87352 l 12.46293,-66.299999 h 5.45148 l 12.46293,66.299999 h -6.87352 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -120.83335,86.226649 0.68898,3.709811 V 46.087241 h 6.82378 v 66.299999 h -5.58906 l -11.95599,-39.494532 -0.87101,-4.354689 v 43.849221 h -6.82942 V 46.087241 h 5.58941 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -73.865926,46.087241 c 4.306358,0 7.444316,1.680987 9.414933,5.043664 1.969205,3.359503 2.954514,8.030986 2.954514,14.017272 v 28.178125 c 0,5.986286 -0.995187,10.660588 -2.982031,14.022918 -1.984375,3.3595 -5.113867,5.03802 -9.387416,5.03802 H -86.698218 V 46.087241 Z m -6.460067,5.815189 v 54.66397 h 6.002514 c 1.554691,0 2.85115,-0.83925 3.891844,-2.51883 1.402645,-2.32198 2.105378,-5.895269 2.105378,-10.721268 V 65.148177 c 0,-8.83038 -1.999544,-13.245747 -5.997222,-13.245747 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.029213,112.38724 H 3.1994358 V 46.087241 H 16.031727 c 8.550981,0 12.827,5.009092 12.827,15.025864 v 10.082036 c 0,4.645378 -1.094317,8.304036 -3.279775,10.974564 -2.182989,2.671938 -5.366103,4.007202 -9.547225,4.007202 h -6.002514 z m 0,-60.48481 v 28.459288 h 6.002514 c 1.954036,0 3.442406,-0.717902 4.465108,-2.155119 1.020939,-1.436158 1.532114,-3.773311 1.532114,-7.011458 V 61.113105 c 0,-6.14045 -1.999544,-9.210675 -5.997222,-9.210675 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 78.252906,98.502257 c 0,4.674303 -1.093964,8.349543 -3.279422,11.024303 -2.182989,2.67194 -5.366102,4.0072 -9.547225,4.0072 -4.219575,0 -7.412566,-1.33526 -9.580033,-4.0072 -2.16923,-2.67476 -3.252258,-6.35 -3.252258,-11.024303 V 60.242449 c 0,-4.670424 1.083028,-8.34143 3.252258,-11.013369 2.167467,-2.674761 5.360458,-4.012847 9.580033,-4.012847 8.550628,0 12.826647,5.009092 12.826647,15.026216 z m -8.659283,7.424913 c 1.219553,-1.52823 1.829858,-4.00332 1.829858,-7.424913 V 60.242449 c 0,-6.136569 -1.999544,-9.205383 -5.997222,-9.205383 -1.955447,0 -3.445227,0.719314 -4.470399,2.15512 -1.02235,1.433336 -1.532467,3.784247 -1.532467,7.050263 v 38.259808 c 0,3.271313 0.510117,5.625043 1.532467,7.060843 1.025172,1.43334 2.514952,2.14983 4.470399,2.14983 1.86302,0 3.252259,-0.59513 4.167364,-1.78576 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 130.03151,98.502257 c 0,4.674303 -1.09432,8.349543 -3.27977,11.024303 -2.18299,2.67194 -5.36611,4.0072 -9.54723,4.0072 -4.21922,0 -7.41221,-1.33526 -9.58003,-4.0072 -2.16888,-2.67476 -3.25226,-6.35 -3.25226,-11.024303 V 60.242449 c 0,-4.670424 1.08338,-8.34143 3.25226,-11.013369 2.16782,-2.674761 5.36081,-4.012847 9.58003,-4.012847 8.55098,0 12.827,5.009092 12.827,15.026216 z m -8.65964,7.424913 c 1.21956,-1.52823 1.82986,-4.00332 1.82986,-7.424913 V 60.242449 c 0,-6.136569 -1.99954,-9.205383 -5.99722,-9.205383 -1.95509,0 -3.44487,0.719314 -4.47005,2.15512 -1.0227,1.433336 -1.53246,3.784247 -1.53246,7.050263 v 38.259808 c 0,3.271313 0.50976,5.625043 1.53246,7.060843 1.02518,1.43334 2.51496,2.14983 4.47005,2.14983 1.86337,0 3.25226,-0.59513 4.16736,-1.78576 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 162.92945,106.61615 h 17.27482 v 5.77109 H 156.14941 V 46.175436 h 6.78004 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 209.99071,96.898176 c 0,2.1717 0.10619,3.861154 0.31962,5.065534 0.21237,1.2058 0.56373,2.25178 1.05304,3.13655 0.79375,1.43722 2.41159,2.15512 4.85598,2.15512 1.77095,0 3.09245,-0.3429 3.96346,-1.03082 0.87066,-0.68615 1.46615,-1.83797 1.78576,-3.45581 0.32244,-1.62066 0.48507,-4.035071 0.48507,-7.243232 0,-3.298825 -0.68897,-6.002514 -2.06692,-8.108244 -1.37548,-2.108553 -3.43676,-4.003322 -6.18455,-5.682897 -2.47368,-1.528234 -4.50356,-3.109031 -6.09106,-4.740628 -1.5875,-1.634419 -2.80988,-3.567641 -3.66571,-5.798608 -0.8569,-2.229908 -1.28412,-4.886678 -1.28412,-7.970661 0,-4.092928 0.31962,-7.408333 0.95885,-9.9441 0.64241,-2.535414 1.90324,-4.511675 3.78143,-5.9309 1.88101,-1.422047 4.65384,-2.133247 8.31779,-2.133247 3.5747,0 6.29497,0.534811 8.15799,1.604081 1.86337,1.069269 3.14466,2.750608 3.84775,5.043663 0.70132,2.290234 1.05269,5.465234 1.05269,9.525 h -6.82414 c 0,-2.350911 -0.10865,-4.076347 -0.32526,-5.175955 -0.21343,-1.098197 -0.5648,-2.107142 -1.05269,-3.026128 -0.79375,-1.433336 -2.413,-2.149828 -4.85634,-2.149828 -1.772,0 -3.09209,0.351367 -3.9631,1.052689 -0.87101,0.703086 -1.46615,1.893711 -1.78612,3.571875 -0.31961,1.679928 -0.47942,4.200525 -0.47942,7.56285 0,3.296355 0.68615,6.000044 2.06163,8.108244 1.37372,2.109964 3.43535,4.004733 6.18455,5.68325 2.47227,1.525411 4.50356,3.105856 6.09106,4.740275 1.59032,1.635831 2.81234,3.569053 3.66536,5.798961 0.85584,2.226733 1.28447,4.883503 1.28447,7.970308 0,4.03225 -0.31433,7.247112 -0.94263,9.646352 -0.62547,2.39642 -1.88383,4.23757 -3.77578,5.52309 -1.89336,1.28306 -4.67289,1.9237 -8.34002,1.9237 -3.57187,0 -6.29214,-0.50271 -8.15798,-1.51024 -1.86302,-1.01 -3.14607,-2.61409 -3.8474,-4.81189 -0.70273,-2.20098 -1.05269,-5.3333 -1.05269,-9.398354 z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path162"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo_text.35fd3d25.svg";
export { ForwardRef as ReactComponent };